import { createContext } from "react";

export type GroupedRadioContextProps = {
  name: string;
  hasError: boolean;
  value?: string | null;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  "aria-labelledby": string;
};

export const GroupedRadioContext = createContext<GroupedRadioContextProps>({
  name: "",
  value: null,
  hasError: false,
  onChange: () => {},
  "aria-labelledby": "",
});
